module.exports = __webpack_public_path__ + "img/login_icon.240d7453.svg";